import { Grid } from '@material-ui/core'
import {
  CrudForm,
  useEntityManager,
  AuthContext,
  Select,
  RichText
} from 'elentari'
import React, { useContext, useState } from 'react'
import { Field } from 'react-final-form'
import * as yup from 'yup'
import yupValidation from '../../lib/yupValidation'
import * as R from 'ramda'
import MensagemRepository from './MensagemRepository'
import EditorToolbarConfig from './ToolbarConfig'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'
import { CustomAutocomplete } from '../../components'
import { REALMS } from '../Usuarios/Usuarios'
const MensagemForm = ({ ...props }) => {
  const [cargo, setCargo] = useState(false)

  const authContext = useContext(AuthContext)
  const usuario = authContext.user

  const onSubmit = data => {
    const realm = data?.realm || ''
    return entityManager.onSubmit({
      ...data,
      criadorId: usuario?.id,
      eCargo: cargo,
      realm
    })
  }

  const normalizeInitialValues = item => {
    if (item?.eCargo && !cargo) {
      setCargo(item?.eCargo)
    }
    if (!R.isEmpty(item) && item?.mensagemUsuarios) {
      item.mensagemUsuarios = item?.mensagemUsuarios?.map(el => el?.usuarioId)
    }
  }

  const entityManager = useEntityManager({ repository: MensagemRepository })

  const escreverMensagemSchema = yup.object().shape({
    mensagem: yup
      .string()
      .min(5, 'Mínimo de 5 caracteres')
      .trim()
      .required('Obrigatório'),
    eCargo: yup.boolean().required('Obrigatório'),
    realm: yup
      .string()
      .default('')
      .nullable()
      .when('eCargo', {
        is: true,
        then: yup.string().required('Obrigatório')
      }),
    mensagemUsuarios: yup
      .array()
      .default([])
      .nullable()
      .when('eCargo', {
        is: false,
        then: yup
          .array()
          .of(yup.number())
          .required('Obrigatório')
      })
  })
  const validate = yupValidation(escreverMensagemSchema)

  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={onSubmit}
      withPaper
      validate={validate}
      initialValues={normalizeInitialValues(entityManager.item)}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Field
            name="eCargo"
            label="Enviar mensagens para"
            component={Select}
            options={[
              { label: 'Pessoas', value: false },
              { label: 'Cargo', value: true }
            ]}
            onChange={event => setCargo(event.target.value)}
            fullWidth
            hideEmpty
          />
        </Grid>
        {!!cargo && (
          <>
            <Grid item xs={12} sm={6}>
              <Field
                name="realm"
                label="Cargos"
                tipo="cargos"
                component={CustomAutocomplete}
                options={REALMS}
                fullWidth
                hideEmpty
              />
            </Grid>
          </>
        )}
        {!cargo && (
          <Grid item xs={12} sm={6}>
            <Field
              name="mensagemUsuarios"
              label="Usuários"
              tipo="pessoas"
              labelOption="mensagem"
              component={UsuarioAutocomplete}
              fullWidth
              isMulti
              hideEmpty
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Field
            fullWidth
            name="mensagem"
            label="Escreva a mensagem"
            component={RichText}
            toolbarConfig={EditorToolbarConfig}
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default MensagemForm
